import React, { Component } from 'react'
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { boolean } from '@storybook/addon-knobs';

import './css/knowledge.css'
import './css/mentees.css'

class Mentees extends Component {
    render() {
        const tooglesGroupId = 'Toggles';

        const getConfigurableProps = () => ({
            showArrows: boolean('showArrows', false, tooglesGroupId),
            showStatus: boolean('showStatus', false, tooglesGroupId),
            showThumbs: boolean('showThumbs', true, tooglesGroupId),
        })
        return (
            <div className="mentees">
                <div className="mentees-image">
                    <div className="mentees-text">
                        <h1 className="bold">OUR MENTEES</h1>
                        <h4 className="mt-10">Before transitioning to being an online learning platform, we have indulged in several training workshops and programs- training several individuals from different parts of the world. We can boast about our mentee’s doing so well independently and even being mentors themselves.</h4>
                    </div>
                </div>
                <div className="mentees-ment mentslide">
                    <Carousel autoPlay {...getConfigurableProps()} >
                        <div className="flexThis">
                            <div className="mentees-test">
                                <h1> Albert Emiantor Jr.</h1>
                                <span>Part-time Trader</span>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
                            </div>
                            <div className="mentees-test">
                                <h1> Ayodeji Gabriel</h1>
                                <span>Part-time Trader</span>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
                            </div>
                        </div>
                        <div className="flexThis">
                            <div className="mentees-test">
                                <h1> Albert Emiantor Jr.</h1>
                                <span>Part-time Trader</span>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
                            </div>
                            <div className="mentees-test">
                                <h1> Ayodeji Gabriel</h1>
                                <span>Part-time Trader</span>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
                            </div>
                        </div>
                    </Carousel>
                </div>
                <div className="mentees-ment testSmall">
                    <div className="mentees-test">
                        <h1> Albert Emiantor Jr.</h1>
                        <span>Part-time Trader</span>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
                    </div>
                    <div className="mentees-test">
                        <h1> Ayodeji Gabriel</h1>
                        <span>Part-time Trader</span>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
                    </div>
                </div>
            </div>  
        )
    }
}

export default Mentees;